import LinkedinLogo from "src/Content/Images/SocialMedia/Linkedin.svg"
import YouTubeLogo from "src/Content/Images/SocialMedia/YouTube.svg"
import InstagramLogo from "src/Content/Images/SocialMedia/Instagram.svg"
import TwitterLogo from "src/Content/Images/SocialMedia/Twitter.svg"
import FacebookLogo from "src/Content/Images/SocialMedia/Facebook.svg"

export default [
  {
    url: "https://www.youtube.com/user/GTMarketing100",
    src: YouTubeLogo,
    alt: "Youtube Icon",
  },
  {
    url: "https://www.facebook.com/GTEquine",
    src: FacebookLogo,
    alt: "Facebook Icon",
  },
  {
    url: "https://twitter.com/GT_Treatment",
    src: TwitterLogo,
    alt: "Twitter Icon",
  },
  {
    url: "https://www.instagram.com/grastontechnique/",
    src: InstagramLogo,
    alt: "Instagram Icon",
  },
  {
    url: "https://www.linkedin.com/company/graston-technique",
    src: LinkedinLogo,
    alt: "Linkedin Icon",
  },
]

export const FooterLinkLists = {
  clinicians: [
    {
      title: "Clinicians",
      links: [
        {
          key: 1,
          name: "Resources",
          url: "/Clinicians/Resources/",
        },
        {
          key: 2,
          name: "Products",
          url: "/Clinicians/Products/",
        },
        {
          key: 3,
          name: "Trainings",
          url: "/Clinicians/Trainings/",
        },
      ],
    },
    {
      title: "Company",
      links: [
        {
          key: 4,
          name: "About",
          url: "/AboutUs/",
        },
        {
          key: 5,
          name: "Contact Us",
          url: "/Contact/",
        },
        {
          key: 6,
          name: "Privacy",
          url: "/PrivacyPolicy/",
        }
      ],
    },
  ],
}
